import {
  selectIsAuthenticationLoading,
  selectPortalSessionUrl,
  selectUserInfos,
} from "domain/auth/auth.selectors";
import { HiOutlineExternalLink } from "react-icons/hi";
import { useAppDispatch, useAppSelector } from "ui/hook/store";
import { translate } from "ui/i18n";
import { useWindowWidth } from "ui/utils/hooks";
import { PrimaryButton } from "ui/pages/app/components/buttons/PrimaryButton";
import DesktopBanner from "ui/assets/svg/account-bg/desktop-pink-300.svg";
import MobileBanner from "ui/assets/svg/account-bg/mobile-pink-300.svg";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { getStripeCustomerSession } from "domain/auth/auth.actions";

export function SubcriptionManagement() {
  const user = useAppSelector(selectUserInfos);
  const portalSessionUrl = useAppSelector(selectPortalSessionUrl);
  const isLoading = useAppSelector(selectIsAuthenticationLoading);
  const dispatch = useAppDispatch();
  const isDesktop = useWindowWidth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!user?.isPremium && !!user?.subscription?.customer_id) {
      dispatch(getStripeCustomerSession()).unwrap();
    }
  }, [user, user?.isPremium, user?.subscription?.customer_id]); //eslint-disable-line

  const handlePortalClick = () => {
    if (portalSessionUrl) {
      window.open(portalSessionUrl, "_blank");
    }
  };

  const openChangeAccountType = () => {
    navigate("/change-account-type", {
      state: {
        email: user?.email,
        accountExists: true,
      },
    });
  };

  return user?.isPremium ? (
    <button
      className="flex w-full items-center justify-between p-4 py-6 disabled:opacity-30 md:p-6"
      onClick={handlePortalClick}
      disabled={!portalSessionUrl}
    >
      <span className="text-md font-medium text-secondaryGrey-800">
        {translate("ns1:Account.ManageSubscription")}
      </span>
      <HiOutlineExternalLink size={24} color="#485585" />
    </button>
  ) : (
    <div className="p-4 py-6 md:p-6">
      <div
        className="relative w-full rounded-[20px] bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url(${isDesktop ? DesktopBanner : MobileBanner})`,
        }}
      >
        <div className="flex flex-col justify-center space-y-3 p-6">
          <div className="w-fit rounded-[36px] bg-pink-100 px-2 py-0.5 text-xs font-semibold text-secondaryGrey-900">
            {translate("ns1:Account.Premium")}
          </div>
          <p className="text-sm font-bold text-secondaryGrey-900 md:text-base">
            {translate("ns1:Account.SubscriptionText")}
          </p>
          <PrimaryButton
            className="w-fit"
            disabled={isLoading}
            onClick={openChangeAccountType}
          >
            {translate("ns1:Button.Discover")}
          </PrimaryButton>
        </div>
      </div>
    </div>
  );
}
